/*
  Kleine Ladeanzeige für einzelne Bedienelemente.

  Das Design System kennt nur AppLoadingOverlay für ganze Bereiche; für einen
  Knopf oder ein Farbfeld wäre das zu viel. Diese Komponente verwendet dieselben
  Punkte in klein, damit im Schichtplan überall dieselbe Ladesprache steht.
*/

import React from "react";

export default function ShiftplanBusyDots({ className = "", label = "Wird gespeichert" }) {
  return (
    <span
      className={`ds-loading-overlay__spinner-dots spv2-busy-dots${className ? ` ${className}` : ""}`}
      role="status"
      aria-label={label}
    >
      <span className="ds-loading-overlay__spinner-dot" />
      <span className="ds-loading-overlay__spinner-dot" />
      <span className="ds-loading-overlay__spinner-dot" />
    </span>
  );
}
